import axios from 'axios';
import BASEURL from '../BaseUrl';
import { logoutApi } from './AuthApi';

export const testDbConnection = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/admin-console/test-database-connection`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }

    throw error;
  }
};

export const testSnowflakeConnection = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/admin-console/test-snowflake-connection`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }

    throw error;
  }
};

export const testS3SecretConnection = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/admin-s3-console/connect-s3-datalake`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }

    throw error;
  }
};

export const testADLSSecretConnection = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/admin-azure-console/connect-azure-datalake`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }

    throw error;
  }
};

export const testS3Connection = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/admin-s3-console/test-s3-connection`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const testAzureConnection = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/admin-azure-console/test-adls-connection`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const connectOtherDatabase = async (secret_name, connector_type, connection_type) => {
  const data = {
    secretName: secret_name,
    connectorType: connector_type,
    connectionType: connection_type,
  };
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/admin-console/connect-new-database`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getCsvData2 = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/admin-s3-console/getCsvHeaders`, {
      params: { fileKey: data.path, secretName: data.secretName },
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }

    throw error;
  }
};

export const getCsvDataAzure = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/admin-azure-console/getCsvHeaders`, {
      params: { fileKey: data.path, secretName: data.secretName },
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }

    throw error;
  }
};

export const getSecretsList = async (connectorType) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/admin-console/get-secrets-by-connection_type`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { connectorType },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const addSecret = async (data) => {
  let secretDto;
  if (data?.engine === 's3') {
    secretDto = {
      secretName: data?.secretName,
      connectorType: data?.connectorType,
      bucketName: data?.bucketName,
      awsAccessKey: data?.awsAccessKey,
      awsSecretKey: data?.awsSecretKey,
      awsSessionToken: data?.awsSessionToken,
      region: data?.region,
    };
  } else if (data?.engine === 'snowflake') {
    secretDto = {
      secretName: data?.secretName,
      connectorType: data?.connectorType,
      username: data?.username,
      password: data?.password,
      engine: data?.engine,
      database: data?.database,
      account: data?.account,
      warehouse: data?.warehouse,
      role: data?.role,
    };
  } else if (data?.engine === 'adls') {
    secretDto = {
      secretName: data?.secretName,
      connectorType: data?.connectorType,
      storageAccountKey: data?.storageAccountKey,
      storageAccount: data?.storageAccount,
      containerName: data?.containerName,
      endpointSuffix: data?.endpointSuffix,
    };
  } else {
    secretDto = {
      secretName: data?.secretName,
      connectorType: data?.connectorType,
      username: data?.username,
      password: data?.password,
      engine: data?.engine,
      host: data?.host,
      port: data?.port,
      database: data?.database,
    };
  }

  if (data?.engine === 'oracle' && data.serviceName) {
    secretDto.serviceName = data.serviceName;
  }

  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/secrets-console/add`, secretDto, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }

    throw error;
  }
};

export const editSecret = async (data) => {
  let secretDto;
  if (data?.engine === 's3') {
    secretDto = {
      secretName: data?.secretName,
      connectorType: data?.connectorType,
      bucketName: data?.bucketName,
      awsAccessKey: data?.awsAccessKey,
      awsSecretKey: data?.awsSecretKey,
      awsSessionToken: data?.awsSessionToken,
      region: data?.region,
    };
  } else if (data?.engine === 'snowflake') {
    secretDto = {
      secretName: data?.secretName,
      connectorType: data?.connectorType,
      username: data?.username,
      password: data?.password,
      engine: data?.engine,
      database: data?.database,
      account: data?.account,
      warehouse: data?.warehouse,
      role: data?.role,
    };
  } else if (data?.engine === 'adls') {
    secretDto = {
      secretName: data?.secretName,
      connectorType: data?.connectorType,
      storageAccountKey: data?.storageAccountKey,
      storageAccount: data?.storageAccount,
      containerName: data?.containerName,
      endpointSuffix: data?.endpointSuffix,
    };
  } else {
    secretDto = {
      secretName: data?.secretName,
      connectorType: data?.connectorType,
      username: data?.username,
      password: data?.password,
      engine: data?.engine,
      host: data?.host,
      port: data?.port,
      database: data?.database,
    };
  }

  if (data?.engine === 'oracle' && data.serviceName) {
    secretDto.serviceName = data.serviceName;
  }

  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/admin-console/edit-secret`, secretDto, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }

    throw error;
  }
};

export const getSecretsById = async (id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/admin-console/get-secret-by-id`, {
      params : {id},
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const deleteSecret = async (id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.delete(`${BASEURL}/admin-console/delete-secret`, {
      params : {id},
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getSecretsListByCurrentUserName = async (page = 0, size = 5, secret_name = "") => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/admin-console/get-secrets`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: {page, size,  secret_name: secret_name && secret_name.trim() !== "" ? secret_name.trim() : null}
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};
